import defaultTo from 'lodash/fp/defaultTo';
import flow from 'lodash/fp/flow';
import has from 'lodash/fp/has';
import head from 'lodash/fp/head';
import split from 'lodash/fp/split';
import { createIntl, createIntlCache, IntlShape } from 'react-intl';

const DEFAULT_LOCALE = 'en-GB';
const DEFAULT_LANG = 'en';

interface LocaleMap {
  [key: string]: string;
}

const supportedLocaleMap: LocaleMap = {
  de: 'de-DE',
  'de-DE': 'de-DE',
  en: 'en-GB',
  'en-GB': 'en-GB',
  fr: 'fr-FR',
  'fr-FR': 'fr-FR',
};

const extractLanguage = flow(defaultTo(DEFAULT_LOCALE), split('-'), head);

const extractLanguageForGlossar = (value: string | undefined | null): string => {
  const extractedLanguage = extractLanguage(value);
  if (extractedLanguage) {
    return extractedLanguage;
  } else {
    return DEFAULT_LANG;
  }
};

const getSupportedLocale = (preferredLocale: string): string =>
  has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;

export {
  DEFAULT_LANG,
  DEFAULT_LOCALE,
  extractLanguage,
  extractLanguageForGlossar,
  getSupportedLocale,
  supportedLocaleMap,
};

const cache = createIntlCache();

let intl: IntlShape | null = null;

export function initIntl(locale: string = "", messages: Record<string, string> = {}) {

  intl = createIntl({ locale, messages }, cache);
}

export function getIntl(): IntlShape {
  if (!intl) {
    throw new Error('Intl has not been initialized');
  }
  return intl;
}
